import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import { FieldRenderProps } from 'react-final-form';
import { mergeClasses } from '@/utils/style';
import { ErrorMessage } from '@/components/inputs/ErrorMessage';
import { useTranslation } from 'react-i18next';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { getCountryCode } from '@/constants/country';
const DynamicInput = dynamic(() => import('react-phone-number-input'), {
  loading: () => <div className="phoneInput PhoneInput">
			<div className="PhoneInputCountry">
				<div aria-hidden="true" className="PhoneInputCountryIcon PhoneInputCountryIcon--border">
					<Image className="PhoneInputCountryIconImg" alt="forms.phone.CZ" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/CZ.svg" width={24} height={16} />
				</div>
				<div className="PhoneInputCountrySelectArrow"></div>
			</div>
			<input autoComplete="tel" placeholder="" id="phoneNumber" data-clarity-mask="true" className="PhoneInputInput" type="tel" name="phoneNumber" />
		</div>,
  ssr: false
});
export function PhoneInput(props) {
  const $ = _c(46);
  const submitError = !props.meta.dirtySinceLastSubmit ? props.meta.submitError : undefined;
  const errorMessage = props.meta.error || submitError;
  const hasError = !!errorMessage && (props.meta.touched || props.meta.submitFailed);
  const errorId = `${props.input.name}-error`;
  const {
    t
  } = useTranslation("core");
  const [isSelected, setIsSelected] = useState(false);
  const t0 = props.input;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["CZ", "SK", "HU"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("forms.phone.CZ");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("forms.phone.SK");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("forms.phone.HU");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      CZ: t2,
      SK: t3,
      HU: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] !== props) {
    t6 = () => {
      setIsSelected(true);
      props.onFocus?.();
    };
    t7 = () => {
      setIsSelected(false);
      props.onBlur?.();
    };
    $[11] = props;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  const t8 = props.hideLabel ? props.label : "";
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = getCountryCode(process.env.NEXT_PUBLIC_LANGUAGE);
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = props.id || props.input.name;
  const t11 = hasError ? errorId : undefined;
  const t12 = hasError ? "true" : "false";
  let t13;
  if ($[15] !== hasError || $[16] !== isSelected || $[17] !== props.className || $[18] !== props.input.value) {
    t13 = mergeClasses("phoneInput", props.className, {
      phoneInputFocused: isSelected || props.input.value
    }, {
      "border-red-500": hasError
    });
    $[15] = hasError;
    $[16] = isSelected;
    $[17] = props.className;
    $[18] = props.input.value;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== props.input || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t14 = <DynamicInput {...t0} countries={t1} labels={t5} onFocus={t6} onBlur={t7} placeholder={t8} defaultCountry={t9} addInternationalOption={false} limitMaxLength={true} id={t10} aria-describedby={t11} aria-invalid={t12} data-clarity-mask="true" className={t13} />;
    $[20] = props.input;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const t15 = props.id || props.input.name;
  let t16;
  if ($[30] !== hasError || $[31] !== props.hideLabel || $[32] !== props.leftIcon) {
    t16 = mergeClasses("labelPhoneInput", {
      "left-11": props.leftIcon
    }, {
      "text-red-500": hasError
    }, {
      hidden: props.hideLabel
    });
    $[30] = hasError;
    $[31] = props.hideLabel;
    $[32] = props.leftIcon;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== props.label || $[35] !== t15 || $[36] !== t16) {
    t17 = <label htmlFor={t15} className={t16}>{props.label}</label>;
    $[34] = props.label;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== errorId || $[39] !== errorMessage || $[40] !== hasError) {
    t18 = hasError && <ErrorMessage error={errorMessage} id={errorId} />;
    $[38] = errorId;
    $[39] = errorMessage;
    $[40] = hasError;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t14 || $[43] !== t17 || $[44] !== t18) {
    t19 = <div className="relative">{t14}{t17}{t18}</div>;
    $[42] = t14;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}